import getStore from '../store';
import { mutator } from 'satcheljs';
import { setCalendarSearchResults } from '../actions/searchResultStoreActions';

/**
 * Sets the calendar search results
 */
export let setCalendarSearchResultsMutator = mutator(setCalendarSearchResults, search => {
    let store = getStore();
    if (search.calendarSearchResults) {
        if (search.clientSorted) {
            search.calendarSearchResults.forEach(function (item) {
                store.searchResults.unshift(item);
            });
        } else {
            store.searchResults = store.searchResults.concat(search.calendarSearchResults);
        }
    }
});
export { default as CalendarSearchResultItem } from '../schema/CalendarSearchResultItem';
